import template from './ordinacijaDetails.html';

class OrdinacijaDetailsController {
    constructor(DS, AppConfiguration, $q, $uibModal, logger) {
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.logger = logger;
        this.icon = false;
        this.pageTitle = 'Ordinacija dentalne medicine:' || false;
        this.pageDesc = 'Podaci o ordinaciji dentalne medicine';
        this.datastore = () => {
            return DS;
        };
        this.naloziListView = AppConfiguration().getViewByEntityAndType('RadniNalog', 'OrdinacijaViews');
        this.korisniciListView = AppConfiguration().getViewByEntityAndType('KorisnikOrdinacija', 'ListView');
        this.korisniciCreateView = AppConfiguration().getViewByEntityAndType('KorisnikOrdinacija', 'CreateView');
    }

    $onInit() {
        this.shouldDisplayActions = true;
        this.pageTitle = `Ordinacija dentalne medicine: ${this.item.naziv}`;
        this.refreshState();
    }

    refreshState() {
        this.getNaloge();
        this.getKorisnike();
    }

    getNaloge() {
        const DS = this.datastore();
        this.resolveReferences()
            .then(() => {
                return DS.findAll('RadniNalog', { ordinacija: this.item.id, aktivne: 1 }, { bypassCache: true });
            })
            .then(response => {
                this.nalozi = response;
            });
    }

    getKorisnike() {
        const DS = this.datastore();
        DS.findAll('KorisnikOrdinacija', { ordinacija: this.item.id }, { bypassCache: true }).then(response => {
            this.korisnici = response.map(item => {
                return {
                    id: item.id,
                    user_id: item.user.id,
                    first_name: item.user.first_name,
                    last_name: item.user.last_name,
                    email: item.user.email,
                    username: item.user.username
                };
            });
        });
    }

    insertKorisnika() {
        const DS = this.datastore();
        const view = this.korisniciCreateView;
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return {};
                },
                view: function() {
                    return view;
                },
                formClass: function() {
                    return 'horizontal';
                }
            }
        });

        modal.result.then(user => {
            DS.create('KorisnikOrdinacija', { ordinacija: this.item.id, user: user }, { cacheResponse: true })
                .then(response => {
                    this.refreshState();
                })
                .catch(error => {
                    this.logger.error('Oops...', error.data);
                });
        });
    }

    deleteKorisnika(item) {
        const DS = this.datastore();
        const previousWindowKeyDown = window.onkeydown;
        swal(
            {
                title: `Brisanje korisnika`,
                text: `Za potvrdu brisanja upišite 'da'`,
                type: 'input',
                showCancelButton: true,
                closeOnConfirm: false
            },
            inputValue => {
                window.onkeydown = previousWindowKeyDown;
                if (inputValue === false) return false;
                if (inputValue === 'da') {
                    DS.destroy('KorisnikOrdinacija', item.id).then(
                        data => {
                            this.refreshState();
                            swal('Redak obrisan', '', 'success');
                        },
                        error => {
                            swal('Greška', `Došlo je do greške prilikom brisanja`, 'error');
                        }
                    );
                    return true;
                }
                swal.showInputError('Nedozvoljena vrijednost');
                return false;
            }
        );
    }

    resolveReferences() {
        let models = [];
        let datastore = this.datastore();

        _.forOwn(this.naloziListView.getReferences(), (value, key) => {
            models.push(datastore.definitions[value.targetEntity().name()]);
        });

        return this.$q.all(models.map(m => m.findAll()));
    }
}

OrdinacijaDetailsController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', 'logger'];

const OrdinacijaDetailsComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: OrdinacijaDetailsController,
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
};

export { OrdinacijaDetailsComponent };



// WEBPACK FOOTER //
// ./app/components/ordinacija/ordinacijaDetails.component.js